const Days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];

export const checkWorkshopAvailability = (data) => {
    const today = Days[new Date().getDay()];
    const currentDay = Days[new Date().getDay() - 1]
    const tomorrowFrom = data[`${today}From`];
    if (!(currentDay && tomorrowFrom && data[`${currentDay}From`])) {
        return false
    }
    if (data[`${currentDay}From`]) {
        return false
    }
    if (tomorrowFrom) {
        return `Closed.Opens ${tomorrowFrom} tomorrow`;
    } else {
        let nextDayIndex = new Date().getDay();
        while (!data[`${Days[nextDayIndex % 7]}From`]) {
            nextDayIndex++;
        }
        return `Closed.Opens ${data[`${Days[nextDayIndex % 7]}From`]} ${Days[nextDayIndex % 7]} `;
    }
}